module.exports = __webpack_public_path__ + "static/media/logos_squares_Gold_Sensetime.d171f4f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Gold_Sensetime.png
// module id = 86
// module chunks = 0